import { useState } from 'react';

import { createSimpleStore } from './useSimpleStore';

/**
 * Hook to create and return a single instance of SimpleStore.
 * @example const store = useSimpleStoreInstance(initialState);
 * @param initialState initial value for a store state.
 * @returns the store object
 */
const useSimpleStoreInstance = <T extends Record<string, unknown>>(initialState: T) => {
  return useState(() => createSimpleStore<T>(initialState))[0];
};

export default useSimpleStoreInstance;
